import {countries} from "@global/utilities/global-country-data";

export const states = {
    authenticated: false,
    countries: countries(),
    freeze: false,// Order-Request in progress
    cartData: {},
    cartFanboxThreshold: 100,
    cartFanboxItems: [],
    cartSelectFanbox: true,
    cartErrorItems: [],
    cartOrderQuantity: {}
};
